import React from 'react';
import PropTypes from 'prop-types';
import getImageState from '../../services/transforImage';

import './style.css';


const BalanceComponent = ({ coins, text }) => {
  const setIcon = getImageState("coin");
  return (

    <div className="flex justify-between items-center details-balance">
      <img src={setIcon.src} alt={setIcon.alt}/>
      <div className="balance-total">
        <h1>{coins} <small>coins</small></h1>
        <small>{text}</small>
      </div>
    </div>
  )
}

BalanceComponent.propTypes = {
  coins: PropTypes.number,
  text: PropTypes.string,
}

export default BalanceComponent;
